// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Utils = require("../../../utils/Utils.bs.js");
let React = require("react");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let TailwindMerge = require("tailwind-merge");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");

function ConversationMessageArea(props) {
  let __buttons = props.buttons;
  let __attachments = props.attachments;
  let __textInputDisabled = props.textInputDisabled;
  let __onChangeTextProp = props.onChangeText;
  let maxHeight = props.maxHeight;
  let __isFocused = props.isFocused;
  let isFocused = __isFocused !== undefined ? __isFocused : false;
  let onChangeTextProp = __onChangeTextProp !== undefined ? __onChangeTextProp : prim => {};
  let textInputDisabled = __textInputDisabled !== undefined ? __textInputDisabled : false;
  let attachments = __attachments !== undefined ? __attachments : null;
  let buttons = __buttons !== undefined ? __buttons : null;
  let fallbackRef = React.useRef(null);
  let inputRef = Stdlib_Option.getOr(props.inputRef, fallbackRef);
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("textarea", {
        ref: Primitive_option.some(i => {
          Utils.React.setCurrentRef(inputRef, i);
        }),
        className: "w-full border border-transparent resize-none bg-white p-0.5 text-black text-lg md:text-base",
        style: maxHeight !== undefined ? ({
            maxHeight: maxHeight,
            overflowY: "auto"
          }) : ({}),
        disabled: textInputDisabled,
        placeholder: props.placeholder,
        value: Stdlib_Option.getOr(props.text, ""),
        onKeyDown: props.onKeyDown,
        onFocus: props.onFocus,
        onBlur: props.onBlur,
        onChange: evt => {
          let e = evt.target.value;
          let element = inputRef.current;
          if (!(element == null)) {
            element.setAttribute("style", "height:auto");
            let height = element.scrollHeight + 2 | 0;
            element.setAttribute("style", "height:" + (height.toString() + "px"));
          }
          onChangeTextProp(e);
        }
      }),
      attachments,
      buttons
    ],
    className: TailwindMerge.twMerge([
      "w-full p-1.5 leading-tight bg-white border border-zinc-300 rounded-md transition-colors duration-150 hover:cursor-text",
      isFocused ? "border-tan-gold-light" : "hover:border-zinc-400"
    ]),
    id: "conversation-message-area",
    onClick: evt => {
      let eventTarget = evt.target;
      let match = inputRef.current;
      let match$1 = eventTarget.nodeName !== "BUTTON";
      if (!(match == null) && match$1 && !isFocused) {
        return match.focus();
      }
    }
  });
}

let make = ConversationMessageArea;

exports.make = make;
/* Utils Not a pure module */
